export default "__VITE_ASSET__C1DO9hrQ__"